import {
    GameRoundConfig,
    GameRoundManager
} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundManager";
import {TombOfAkhenatenParsedGameData} from "../server/data/TombOfAkhenatenParsedGameData";
import {TombOfAkhenatenGameMode} from "../gameMode/TombOfAkhenatenGameMode";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";

export class TOAGameRoundManager extends GameRoundManager {
    constructor(gameRound: GameRoundConfig) {
        super(gameRound);
        NolimitApplication.events.on("checkTransitionForActionSpins", () => {
            (this as any).checkTransition();
        })
    }

    onAllCustomFinalSpinStarted(data: TombOfAkhenatenParsedGameData) {
        super.onGameData(data);
    }

    onGameData(data: TombOfAkhenatenParsedGameData) {
        if (data.mode == TombOfAkhenatenGameMode.RESPIN_FINAL) {
            //call to super is moved to onAllCustomFinalSpinStarted function as we are starting spin after pyramid stopped
        } else {
            super.onGameData(data);
        }
    }
}